import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAddNewMessageMutation } from "./messageApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave } from "@fortawesome/free-solid-svg-icons"
import TimeLeft from '../../partial/TimeLeft'
import Uploader from "../../partial/Uploader"
import ReactQuill from 'react-quill';

const NewMessageForm = ({ groups, usersList }) => {
    const {groupId, type} = useParams()
    const [addNewMessage, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewMessageMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState('')
    const [body, setBody] = useState('')
    const [group, setGroup] = useState(groupId!='0'?groupId:'')
    const [active, setActive] = useState(true)
    const [order, setOrder] = useState(0)

    const [specificUsers, setSpecificUsers] = useState(false)
    const [users, setUsers] = useState([])
    const [toDate, setToDate] = useState(new Date(new Date().setDate(new Date().getDate() + 7)))
    const [img, setImg] = useState('')
    useEffect(() => {
        if (isSuccess) {
            setTitle('')
            setBody('')
            setGroup(groupId!='0'?groupId:'')
            setOrder(0)
            setActive(true)
        }
    }, [isSuccess, groupId, navigate])

   
    const canSave = [title, body, group,  toDate].every(Boolean) && !isLoading

    const onSaveMessageClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
         const {data} =    await addNewMessage({ group, title, body, active, specificUsers, users,  toDate , order, img})
         if(data?.id)
            navigate(`/${type}/${groupId}/messages`)
        }
    }


    
    const onUsersChanged = e => {
        const values = Array.from(
            e.target.selectedOptions, //HTMLCollection 
            (option) => option.value
        )
        setUsers(values)
    }
    const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })

    const usersOptions = usersList?.map(user => {
        return (
            <option
                key={user.id}
                value={user.id}
            > {user.name}</option >
        )
    })

    const errClass = isError ? "errmsg" : "offscreen"

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveMessageClicked}>
                <div className="form__title-row">
                    <h2>New Message</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/messages`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="title">
                    Title:</label>
                <input
                    className={`form__input  ${!title &&'form__input--incomplete'}`}
                    id="title"
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                />
               

                <label className="form__label" htmlFor="body">
                    Body:</label>

                    <ReactQuill                   
                    value={body}
                    onChange={setBody}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          //[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{size: []}],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />    
                {/* <textarea
                    className={`form__input form__input--text ${!body &&'form__input--incomplete'}`}
                    id="body"
                    name="body"
                    value={body}
                    onChange={(e)=>setBody(e.target.value)}
                /> */}
                 <Uploader label={'Img'} folderId={'MANAGE_TASKS'} file={img} setFile={setImg} isImg={true} />

                
                <div className="form-flex">

                <div className="form-input-container">

                <label className="form__label form__title-row" htmlFor="toDate">
                   <span> To Date:</span> <small > (<TimeLeft endtime={toDate} />)</small> </label>
                <input
                    className={`form__input  ${!toDate &&'form__input--incomplete'}`}
                    id="toDate"
                    name="toDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${toDate.getFullYear().toString()}-${(toDate.getMonth() + 1).toString().padStart(2, 0)}-${toDate.getDate().toString().padStart(2, 0)}T${toDate.getHours().toString().padStart(2, 0)}:${toDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setToDate(new Date(e.target.value))}
                />
                </div>
                </div>
                <div className="form-flex">
                <div className="form-input-container">


                    <label className="form__label form__checkbox-container" htmlFor="group">
                        GROUP:</label>
                    <select
                        id="group"
                        name="group"
                        className={`form__input  ${!group &&'form__input--incomplete'}`}
                        value={group}
                        onChange={(e)=>setGroup(e.target.value)}
                    >
                        <option></option>
                        {options}
                    </select>
                </div>
                <div className="form-input-container">
                  <label className="form__label" htmlFor="action-order">
                    Order:</label>
                <input
                    className={`form__input `}
                    id="action-order"
                    name="order"
                    type="number"
                    autoComplete="off"
                    value={order}
                    onChange={(e)=>setOrder(e.target.value)}
                />
                </div>
               

     
                </div>
                <div className="form-flex">
                <div className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="specific-users">
                    SPECIFIC USERS:
                    <input
                        className="form__checkbox"
                        id="specific-users"
                        name="specific-users"
                        type="checkbox"
                        checked={specificUsers}
                        onChange={(e)=>setSpecificUsers(prev => !prev)}
                    />
                </label>

                <label className="form__label" htmlFor="users">
        Users:</label>
    <select
        id="users"
        name="users"
        className={`form__select `}
        multiple={true}
        size="3"
        value={users}
        onChange={onUsersChanged}
    >
        {usersOptions}
    </select>                   
                </div>
             
               

     
                </div>
                <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>

            </form>
        </>
    )

    return content
}

export default NewMessageForm